/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add material note
 */
export const AddMaterialNoteBody = zod.object({
  title: zod.string(),
  content: zod.string(),
});

export const AddMaterialNoteResponse = zod.int().describe("Note identity.");

/**
 * @summary Edit material note
 */
export const EditMaterialNoteBody = zod.object({
  title: zod.string(),
  content: zod.string(),
});

export const EditMaterialNoteResponse = zod.void();

/**
 * @summary Remove material note
 */
export const RemoveMaterialNoteResponse = zod.void();
